import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { openProductModal } from "../../../redux/features/productModalSlice";
import Search from "../../../common/Search";
import {
  ViewPurchaseProducts
} from "../../../redux/services/PurchaseService/purchase.Services";
import Swal from "sweetalert2";
import { Pagination } from "react-bootstrap";
import { useSelector } from "react-redux";
function ViewPurchaseProductList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [product, setProduct] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const refreshData = useSelector(
    (state) => state.productModal.refreshData
  );
  const fetchProduct = async () => {
    try {
      setLoading(true);

      const payload = {
        id: Number(id),
        page,
        search,
        status,
      };
      const res = await ViewPurchaseProducts(payload);
      setProduct(res?.data?.purchase_items || []);
      setImageUrl(res?.product_image_url || "");
      setLastPage(res?.last_page || 1);
      setTotalRecords(res?.total || 0);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, [page, search, status, refreshData]);
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= lastPage) {
      setPage(newPage);
    }
  };

  // if (loading) return <h4>Loading...</h4>;

  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title">Purchase Products </h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <span>Purchase Products </span>
              </nav>
            </div>
          </div>
              <div className="d-flex flex-wrap gap-2 justify-content-end">
                <button className="add-btn" onClick={()=>navigate(-1)}>Back</button>

          </div>
        </div>
      </div>
      <div className="main_page">

        {(totalRecords > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search Product..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}
        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>brand</th>
                  <th>unit</th>
                  <th>Stock</th>
                  <th>Purchase Price</th>
                  <th>Selling Price</th>
                  {/* <th>Change Status</th> */}
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {product.length > 0 ? (
                  product.map((item, index) => (
                    <tr key={item.id}>
                        {/* <td> {(page - 1) * limit + index + 1}</td> */}
                        <td> {index + 1}</td>

                      <td>
                        <img
                          src={`${process.env.REACT_APP_IMAGE_URL}${imageUrl}/${item.product_details?.image}`}
                          alt={item.product_name}
                          width="40"
                          height="30"
                          style={{
                            objectFit: "cover",
                            borderRadius: "5px",
                          }}
                        />
                      </td>



                      {/* Product Name */}
                      <td>{item.product_details?.product_name}</td>

                      {/* Brand */}
                      <td>{item.product_details?.brands_details?.name || "-"}</td>

                      {/* Unit */}
                      <td>{item.product_details?.units_details?.name || "-"}</td>

                      {/* Current Stock */}
                      <td>
                        {item?.quantity}
                      </td>

                      {/* Selling Price */}
                      <td>
                        ₹{Number(item.product_details?.selling_price || 0).toLocaleString()}
                      </td>
                      <td>
                        ₹{Number(item.purchase_price || 0).toLocaleString()}
                      </td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center">
                      <p className="mb-0">No Data Found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {lastPage > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={lastPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>

    </div>
  );
}

export default ViewPurchaseProductList;